// Others
import axiosClient from './axiosClient';
import { urlApiMasterData } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IMasterData, IQueryMasterData } from '~/utils/interface/masterData';

const masterDataApi = {
  getListMasterData: (params: IQueryMasterData) => {
    const url = urlApiMasterData.getListMasterData;
    return axiosClient.get<IBaseResponse<IListDataResponse<IMasterData[]>>>(url, { params });
  },
};

export default masterDataApi;
